import { Component, OnInit } from '@angular/core';
import { MonitorService } from '../monitor.service';

@Component({
  selector: 'lms-redis',
  templateUrl: './redis.component.html',
  styleUrls: ['./redis.component.scss']
})
export class RedisComponent implements OnInit {
  public count;
  public count2;
  public info;

  constructor(public monitor: MonitorService) {}

  ngOnInit(): void {}

  getRedisInfo(): void {
    this.monitor.getInfo().subscribe((info) => {
      this.info = info;
    });
  }

  countKeys(): void {
    this.monitor.countKeys().subscribe((count) => {
      this.count = count;
    });
  }

  countKeys2(): void {
    this.monitor.countKeys2().subscribe((count) => {
      this.count2 = count;
    });
  }
}
